import React from 'react';
import { Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import IconLibrary from './IconLibrary';
import PermissionButton from './PermissionButton';

function StackablePageButtons({ buttons, backButton = true }) {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
      }}>
      {buttons
        .filter(button => !button?.hidden)
        .map(button => {
          const ButtonComponentType = button?.permissionName
            ? PermissionButton
            : Button;
          return (
            <ButtonComponentType
              {...(button?.permissionName && {
                permissionName: button?.permissionName,
              })}
              startIcon={<button.Icon />}
              key={button.key || button.label}
              size={button.size || 'small'}
              variant={button.variant || 'outlined'}
              color={button.color || 'primary'}
              onClick={button.onClick}
              disabled={button.disabled || false}>
              {button.label}
            </ButtonComponentType>
          );
        })}
      {backButton && (
        <Button
          startIcon={<IconLibrary.Back />}
          size="small"
          variant="outlined"
          color="tertiary"
          onClick={() => navigate(-1)}>
          <FormattedMessage
            id="STACKABLE_PAGE_BUTTONS_BACK_BUTTON"
            defaultMessage="Back"
          />
        </Button>
      )}
    </Stack>
  );
}

export default StackablePageButtons;
